import avatar from "@assets/avatars/avatar-6.svg";
import AvatarWithText from "@core-components/avatar-text/AvatarWithText";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import ButtonVariants from "@core-components/button/ButtonVariants";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack } from "@mantine/core";

interface SkinSearchHeroProps {
  onScrollClick: () => void;
}

export const SkinSearchHero = ({ onScrollClick }: SkinSearchHeroProps) => {
  const { t } = useAppTranslation("pages.skins.search");

  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        header={<SSHeadLineHeader>{t("banner.header")}</SSHeadLineHeader>}
        subTitle={
          <Stack align="center" gap={33}>
            <AvatarWithText avatar={avatar} text={t("banner.shardWarning")} />
            <ButtonVariants.Gradient
              className="w-fit rounded-full"
              label={t("banner.button")}
              onClick={onScrollClick}
            />
          </Stack>
        }
      >
        <SSWhiteText>{t("banner.titlePrefix")}</SSWhiteText>
        <br />
        <SSLoLGradientText>{t("banner.titleSuffix")}</SSLoLGradientText>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};
